/**
 * Pre-LLM keyword filter — zero-cost rule-based pre-filter that runs
 * before the Haiku relevance filter to reject obviously irrelevant content
 * without spending tokens.
 *
 * Matches collected text against scope contract keywords and desk config
 * watchlist terms. Items matching zero keywords never reach the LLM.
 */

export interface PrefilterResult {
  passed: boolean;
  matchedKeywords: string[];
}

/**
 * Check if text contains at least one keyword from scope or watchlist.
 *
 * @param text - Raw collected text to check
 * @param scopeKeywords - Keywords from the investigation scope contract
 * @param watchlistKeywords - Keywords from the desk config entity watchlists
 * @returns Whether the text passed the filter and which keywords matched
 */
export function prefilterByKeywords(
  text: string,
  scopeKeywords: string[],
  watchlistKeywords: string[],
): PrefilterResult {
  const lowerText = text.toLowerCase();
  const allKeywords = [...scopeKeywords, ...watchlistKeywords];
  const matched = allKeywords.filter(kw => lowerText.includes(kw.toLowerCase()));
  return {
    passed: matched.length > 0,
    matchedKeywords: matched,
  };
}
